export type SocialNetworkName = "Instagram" | "Facebook" | "Youtube" | "TikTok" | "X";
export const socialChannelNames = ["facebook", "instagram", "twitter", "linkedin", "tiktok", "youtube"] as const;

export type SocialChannels = (typeof socialChannelNames)[number];

/** Facebook, Instagram, TikTok first; remaining channels after, alphabetically. */
const socialChannelsDisplayPriority: readonly SocialChannels[] = ["facebook", "instagram", "tiktok"];

function socialChannelDisplayRank(channel: SocialChannels): number {
  const priorityIndex = socialChannelsDisplayPriority.indexOf(channel);
  if (priorityIndex !== -1) return priorityIndex;
  return socialChannelsDisplayPriority.length;
}

export function sortSocialChannelsForDisplay(channels: readonly SocialChannels[]): Array<SocialChannels> {
  return [...channels].sort((a, b) => {
    const ra = socialChannelDisplayRank(a);
    const rb = socialChannelDisplayRank(b);
    if (ra !== rb) return ra - rb;
    return a.localeCompare(b);
  });
}

export function getSocialChannelLabel(socialNetworkName: string): string {
  const lowercaseName = socialNetworkName?.toLowerCase?.() ?? "";

  switch (lowercaseName) {
    case "instagram":
      return "Instagram";
    case "facebook":
      return "Facebook";
    case "linkedin":
      return "LinkedIn";
    case "youtube":
      return "YouTube";
    case "tiktok":
      return "TikTok";
    case "twitter":
      return "Twitter";
    default:
      return socialNetworkName;
  }
}

export function capitalizeSocialNetworkName(socialNetworkName: string): string {
  return getSocialChannelLabel(socialNetworkName);
}
